import { HttpEventType } from '@angular/common/http';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Optional,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { throws } from 'assert';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import {
  POINT_OF_CONTACT_EXTRA_REWARD_KEY,
  RECOMMEND_REWARD_KEY,
  RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY,
} from '../site-links/site-links.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { GoogleMapsService } from 'src/app/google-maps.service';
import { Subscription } from 'rxjs';

declare const google: any;
@Component({
  selector: 'app-recommandations-form',
  templateUrl: './recommandations-form.component.html',
  styleUrl: './recommandations-form.component.scss',
})
export class RecommendationsFormComponent
  implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit
{
  selectedFile: File | null = null;

  public pollId = null;
  public optionalImageOne = '';
  public optionalImageTwo = '';

  public optionalImageOneData = null;
  public optionalImageTwoData = null;

  public isOnMap = false;
  selectProduct(prod) {
    this.selectedProduct = prod;
  }
  selectedProduct = null;

  isEdit = false; //just to decide what happens when submit is clicked

  public set onlyVisibleInfos(val: string[]) {
    const allFields = new Set(
      [this.recommTypeNeeds, this.recommTypeHides].flat(2)
    );
    this.hiddenInfos = allFields;
    for (const v of val) {
      this.hiddenInfos.delete(v);
    }
    this.neededInfos = new Set(val);
    console.log(
      'neededInfos',
      this.neededInfos,
      'hiddenInfo',
      this.hiddenInfos
    );
    this.cdr.detectChanges();
  }

  public neededInfos = new Set();
  public hiddenInfos = new Set();

  private readonly recommTypeNeeds = [
    ['region', 'companyName'],
    ['companyName', 'pointOfContact', 'region'],
    ['contact', 'pointOfContact', 'region', 'companyName'],
    ['companyName', 'img', 'addDescr', 'region'],
  ];
  private readonly recommTypeHides = [
    ['promo', 'additionalDescr', 'category', 'contact', 'img'],
    ['img', 'promo', 'additionalDescr'],
    ['img', 'promo', 'additionalDescr'],
    ['name', 'contact', 'checkMark'],
  ];

  public set recommType(val) {
    //if (this.pollId) { //need to open when edit
    this.changeMainPage(2, val);
    //}
    this.cdr.detectChanges();
  }

  public changeMainPage(to, param) {
    console.log({ arguments });
    switch (to) {
      case 1: {
        this.selectedRecommTypeIndex = -1;
        break;
      }
      case 2: {
        this.isNonOptionalDone = false;
        if (!Number.isNaN(Number(param))) {
          this.selectedRecommTypeIndex = param;
        } else {
          console.log('param is ');
        }

        break;
      }
      case 3: {
        this.isNonOptionalDone = true;
        this.isOnMap = true;
        // setTimeout(()=>{
        //     this.initPinMap()

        // }, 5000)
        break;
      }
      case 4: {
        this.isNonOptionalDone = true;
        this.isOnMap = false;
        break;
      }
      default: {
        console.error('Unknown page!', 4);
        break;
      }
    }

    if (
      !this.pollId &&
      this.selectedRecommTypeIndex != -1 &&
      this.selectedRecommTypeIndex < this.recommTypeNeeds.length &&
      this.selectedRecommTypeIndex >= 0
    ) {
      this.neededInfos = new Set(
        this.recommTypeNeeds[this.selectedRecommTypeIndex]
      );
      this.hiddenInfos = new Set(
        this.recommTypeHides[this.selectedRecommTypeIndex]
      );
    } else if (this.selectedRecommTypeIndex != -1) {
      console.error(
        'Invalid value for selectedRecommIndex',
        this.selectedRecommTypeIndex
      );
    }
    console.log(this.neededInfos, this.hiddenInfos);
  }

  public recommendationLatLng = null;

  public selectedRecommTypeIndex = -1;
  @ViewChild('foodSvg')
  public foodSvg: TemplateRef<any>;

  @ViewChild('servicesSvg')
  public servicesSvg: TemplateRef<any>;

  @ViewChild('freelanceSvg')
  public freelanceSvg: TemplateRef<any>;

  @ViewChild('promotionsSvg')
  public promotionsSvg: TemplateRef<any>;

  public readonly recommTypes = [
    {
      name: 'Food', //name is needed later in db
      icon: () => this.foodSvg,
    },
    {
      name: 'Professional Services',
      icon: () => this.servicesSvg,
    },
    {
      name: 'Freelance',
      icon: () => this.freelanceSvg,
    },
    {
      name: 'Promotions',
      icon: () => this.promotionsSvg,
    },
  ];
  public readonly proveMap = ['food', 'services', 'services', 'promotions'];
  public isNonOptionalDone = false;
  public locationInWords = '';
  public companyNameSuggestions = [];
  public setCompanyName(s: string) {
    this.companyNameSuggestions = [];
    this.searchString = s;
    this.getProducts();
    this.sharedService.triggerSelectMyTab(1);
    if (!this.products.length) {
      console.warn('company name found but not product');
      return;
    }
    this.selectedProduct = this.products[0];
    this.cdr.detectChanges();
  }
  public getCompanyNameSuggestions(event) {
    const value = event.target.value
    if (this.selectedRecommTypeIndex == 3 || value.length < 3) {
      return;
    }
    this.auth.getCompanyNameSuggestions(value).subscribe({
      next: (data: any) => {
        this.companyNameSuggestions = data.data;
        this.cdr.detectChanges();
       // console.log('suggs', this.companyNameSuggestions);
      },
      error: console.error,
    });
  }

  public tabs = [{ title: 'Recommend New ' }, { title: 'Search Others' }];
  editRecommId = null;
  public products = [];

  public isMidShowing = false;

  public uploadProgress = 0;
  public selectedSubRegion = null;

  onSubRegionClick(val) {
    this.selectedSubRegion = val;
  }
  public selectedCategoryName = '';
  public selectedCategory = null;

  public set expiry(val) {
    this.selectedPromoExpiry = val;
    this.cdr.detectChanges();
  }

  public set catName(val) {
    this.selectedCategoryName = val;
    this.cdr.detectChanges();
  }

  public categoriesList = [];
  public onCategoryChange(cat) {
    this.selectedCategory = cat;
    this.selectedCategoryName = cat.categoryName;
  }
  public onPromoExpiryChange(val) {
    console.log(val);
    this.selectedPromoExpiry = val;
  }
  public selectedPromoExpiry = '1 Day (Urgent)';

  public readonly promoExpires = ['1 Week', '1 Month', '2 Month', 'Never'];
  public _getCategoryList(): void {
    this.commonService.categoryList.subscribe((val: any) => {
      this.categoriesList = val.map((e) => {
        return {
          keyName: e.name,
          sub: e.subCategory.map((i) => ({
            keyName: i.categoryName,
            ...i,
          })),
        };
      });
    });
  }

  constructor(
    private local: LocalServiceService,
    @Optional()
    public activeModal: NgbActiveModal,
    @Optional()
    private activeBottomSheet: MatBottomSheetRef,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    public roleService: RoleService,
    private commonService: CommonService,
    private customerService: CustomerService,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private googleMapsService: GoogleMapsService
  ) {}
  ngAfterViewInit(): void {
    this.geocoder = new google.maps.Geocoder();
  }
  private geocoder: any;

  @ViewChild('pinMap', { static: false })
  private mapRef: ElementRef;

  private _wasMapOnBefore = false;
  ngAfterViewChecked(): void {
    if (this.mapRef && !this._wasMapOnBefore) {
      this.initPinMap();
      this._wasMapOnBefore = true;
    } else if (!this.mapRef) {
      this._wasMapOnBefore = false;
    }
  }
  ngOnDestroy(): void {
    this._pinSubscription?.unsubscribe();
    this._loginSubs?.unsubscribe();
  }

  private _setPostalCodeAndSubregionCode(streetNameGeoCoding) {
    //
    console.log({ streetNameGeoCoding });
    this.locationInWords = streetNameGeoCoding.streetName;
    console.log('location', this.locationInWords);

    this.postalCode = '';
    this.selectedSubRegion = null;

    if (streetNameGeoCoding.postalCode) {
      this.postalCode = streetNameGeoCoding.postalCode;
    }

    for (const region of this.subRegionList) {
      for (const sub of region.sub) {
        const postalCodePrefixes = JSON.parse(sub.postalCode);
       // console.log({ sub });
        if (!postalCodePrefixes) {
          continue;
        }
        for (const pref of postalCodePrefixes) {
          if ((this.postalCode + '').startsWith(pref)) {
            this.selectedSubRegion = sub;
            this.cdr.markForCheck();
            break;
          }
        }
      }
    }
  }

  public postalCode = '';
  public async geoCodePostalCode() {
    try {
      const latLong = await this.local.getLatLongByPostalCode(
        this.postalCode + ''
      );
      this.recommendationLatLng = latLong;
      this.googleMapsService.removeAllMarkers();
      this.googleMapsService.addMarkerToLocation(latLong, true);

      const streetNameGeoCoding =
        (await this.local.getStreetNameAndSubregionForLocation({
          latLng: latLong,
          postalCode: this.postalCode,
        })) as any;
      this._setPostalCodeAndSubregionCode(streetNameGeoCoding);
      this.cdr.markForCheck();

      console.log('latLng now at ', this.recommendationLatLng);
    } catch (e) {
      console.error(e);
      this.toastr.error('Invalid postal code');
    }
  }
  public readonly MAP_ID = 'pin-loc-map';
  public initPinMap(): void {
    console.log('showing map');

    if (this.sharedService.isBrowser()) {
      this._googleMap = this.googleMapsService.createMap(this.MAP_ID, {
        minZoom: 1,
        maxZoom: 20,
        zoom: 2,
        zoomControl: true,
        styles: [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }],
          },
          {
            featureType: 'administrative',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }],
          },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [{ visibility: 'off' }],
          },
        ],
      });
      this.googleMapsService.initPinMap(this._googleMap, this.MAP_ID);

      this._pinSubscription?.unsubscribe();
      this._pinSubscription = this.googleMapsService.pinSubject$.subscribe(
        async (latLng) => {
          this.recommendationLatLng = latLng;

          // this.geocoder.geocode(
          //   { location: latLng },
          //   (reverseResults: any, reverseStatus: any) => {
          //     ////////console.log(results[0])
          //     if (reverseStatus === 'OK' && reverseResults.length) {
          //       console.log({ reverseResults })
          //       //const addressComponents =

          //       // const routeComponent = addressComponents.find((component: any) =>
          //       //   component.types.includes('route')
          //       // );

          //       // const streetName = routeComponent
          //       //   ? routeComponent.long_name
          //       //   : null;
          //       this.locationInWords  = reverseResults[0].formatted_address;;
          //       this.cdr.markForCheck()
          //     }
          //   }
          // );
          const streetNameGeoCoding =
            (await this.local.getStreetNameAndSubregionForLocation({
              latLng: JSON.stringify(latLng),
            })) as any;
          this._setPostalCodeAndSubregionCode(streetNameGeoCoding);
          this.cdr.markForCheck();

          console.log('latLng now at ', this.recommendationLatLng);
        }
      );
      if (this.recommendationLatLng) {
        this.googleMapsService.addMarkerToLocation(
          this.recommendationLatLng,
          true
        );
      }
    }
  }

  public subRegionList = [];

  private _googleMap = null;
  private _pinSubscription?: Subscription = null;
  ngOnInit(): void {
    this._getRewardAmounts();
    this.subRegionList = this.commonService.regionList.map((i) => {
      return {
        keyName: i.name,
        sub: i.subRegions.map((i: any) => {
          return { ...i, keyName: i.name };
        }),
      };
    });
    this._getCategoryList();
    this.getProducts();
    this._loginSubs = this.local.getUserDetailsObserver().subscribe(user =>{
      if(user){
        this.isLoggedIn = true;
      }
      else{
        this.isLoggedIn = false;
      }
    })
  }

  public uspOneFormOneVal = '';
  public uspOneFormOneErr = '';
  public uspTwoFormOneVal = '';
  public submitRecommendByProduct() {
    this.additionalTags = [this.recommTypes[this.selectedRecommTypeIndex]];

    const data = {
      unqiqueSellingPointOne: this.uspOneFormOneVal,
      unqiqueSellingPointTwo: this.uspTwoFormOneVal,
      productId: this.selectedProduct?.id,
    };

    this.auth.recommendProductFromDb(data).subscribe({
      next: () => {
        this.toastr.success('Successfully recommended!');
        this.closeModal();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Error something went wrong!');
      },
    });
  }
  public searchString = '';
  getProducts() {
    this.customerService
      .getMemberShopProductList({ search: this.searchString, limit: 1010 })
      .subscribe({
        next: (data) => {
          this.products = data.body.data;
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error loading products');
        },
      });
  }

  banner_image_url: string;
  public pointOfContactPointAmount = 'loading...';
  public imagePointAmount = 'loading...';
  public recommPointAmount = 'loading...';

  private _getRewardAmounts() {
    this.auth.getAssignedPointRewards().subscribe({
      error: console.error,
      next: (data) => {
        this.pointOfContactPointAmount =
          data.body.find(
            (tple) => tple.action == POINT_OF_CONTACT_EXTRA_REWARD_KEY
          )?.reward ?? '0';
        this.imagePointAmount =
          data.body.find(
            (tple) => tple.action == RECOMMENDATION_IMAGE_EXTRA_REWARD_KEY
          )?.reward ?? '0';
        this.recommPointAmount =
          data.body.find((tple) => tple.action == RECOMMEND_REWARD_KEY)
            ?.reward ?? '0';
      },
    });
  }

  public isSameFile(fileA, fileB) {
   return this.commonService.isSameFile(fileA, fileB)
  }


  onFileSelect(event: Event, num = 0) {
    const input = event.target as HTMLInputElement;
    if (!(input.files && input.files.length > 0)) {
      return;
    }
    const reader = new FileReader();

    switch (num) {
      case 0: {
        this.selectedFile = input.files[0];
        reader.onload = (event: any) => {
          this.banner_image_url = event.target.result;
        };
        break;
      }
      case 1: {
        this.optionalImageOneData = input.files[0];
        reader.onload = (event: any) => {
          this.optionalImageOne = event.target.result;
        };
        break;
      }
      case 2: {
        this.optionalImageTwoData = input.files[0];
        reader.onload = (event: any) => {
          this.optionalImageTwo = event.target.result;
        };
        break;
      }
      default: {
        throw new Error('Unknown!' + num);
      }
    }
    reader.readAsDataURL(input.files[0]);
  }

  public pointOfContact = '';
  public additionalTags = [];
  public additionalDescr = '';

  public setTag(tag) {
    this.additionalTags = [];
    this.additionalTags.push(tag);
  }
  // public removeTag(tag) {
  //   const tagIndex = this.additionalTags.indexOf(tag);
  //   if (tagIndex == -1) {
  //     console.error(tagIndex);
  //     return;
  //   }
  //   this.tabs.splice(tagIndex, 1);
  // }
  public iHaveTriedService = false;
  public company = '';
  public name = '';
  public contactDetails = '';
  private _clearForm() {
    this.banner_image_url = '';
    this.company = '';
    this.contactDetails = '';
    this.additionalDescr = '';
    this.pointOfContact = '';
    this.name = '';
    this.optionalImageOneData = '';
    this.optionalImageTwoData = '';
    this.optionalImageOne = '';
    this.optionalImageTwo = '';
    this.selectedFile = null;
  }
  public addedByNickname = '';
  public isLoggedIn = false;
  private _loginSubs  = null;
  

  async onSubmit(isByProduct = false) {
    try {
      if (!this.selectedSubRegion && this.selectedRecommTypeIndex != 3) {
        this.toastr.info('Please select a subregion');
        return;
      }
      // if(!this.iHaveTriedService && this.selectedRecommTypeIndex != 3){
      //   this.local.alertInfo({);
      //   return;
      // }

      let needs = this.neededInfos;
      console.log({ needs });

      let errorTitle = '',
        errorMessage = '';
      console.log({ needs });

       if(this.optionalImageOneData && this.optionalImageTwoData
        && this.isSameFile(this.optionalImageOneData, this.optionalImageTwoData)
      ){
        
        errorTitle = 'Duplicate Image',
        errorMessage = 'Cannot use the image file again. please change one of them';

        this.optionalImageTwoData = null;
        this.optionalImageTwo = '';
     
      }
      for (const need of needs) {
        switch (need) {
          case 'checkMark': {
            if (!this.iHaveTriedService) {
              errorTitle = 'Have You Tried?';
              errorMessage =
                'You need to have tried this service before to submit a recommendation';
            }
            break;
          }
          case 'img': {
            if (!this.isEdit) {
              if (!this.banner_image_url) {
                errorTitle = 'Image Missing';
                errorMessage = 'You Need To Add An Image To Continue';
              }
            }
            break;
          }
          case 'companyName': {
            if (!this.company) {
              errorTitle = 'Company Name Missing';
              errorMessage = 'You Need To Add A Company Name To Continue';
            }
            break;
          }
          case 'contact': {
            if (!this.contactDetails) {
              errorTitle = 'Contact Phone Missing';
              errorMessage = 'You Need To Add A Contact Phone To Continue';
            }
            break;
          }
          case 'addDescr': {
            if (!this.additionalDescr) {
              errorTitle = 'Missing Details';
              errorMessage = 'You Need To Add Details To Continue';
            }
            break;
          }
          case 'pointOfContact': {
            if (!this.pointOfContact) {
              errorTitle = 'Point Of Contact Missing';
              errorMessage = 'You Need To Add A Point Of Contact To Continue';
            }
            break;
          }
          case 'region': {
            break;
          }
          default: {
            console.error('Unknown need', need);
            break;
          }
        }
      }
      if(!this.isLoggedIn && !this.addedByNickname){
        errorTitle = 'Missing Nickname';
        errorMessage = 'In order for us to know you, please add a nickname';
      }
      if (errorTitle && errorMessage) {
        this.local.alertInfo({ title: errorTitle, message: errorMessage });
        return;
      }

      if (!this.name && this.selectedRecommTypeIndex != 3) {
        this.local.alertInfo({
          title: 'Missing Info',
          message:
            'You need to add the description for what service they provide',
        });

        return;
      }
      const formData = new FormData();
      formData.append('nameOfServiceProvider', this.name);
      formData.append('phone', this.contactDetails);
      formData.append('company', this.company);
      formData.append('latLng', JSON.stringify(this.recommendationLatLng));
      formData.append(
        'iHaveTriedService',
        this.iHaveTriedService ? 'true' : ''
      );
      if (this.selectedCategory) {
        formData.append('categoryId', this.selectedCategory.categorieChildId);
      }
      formData.append('additionalDescr', this.additionalDescr);
      formData.append('promoExpiry', this.selectedPromoExpiry);

      if (this.selectedFile) {
        formData.append('image', await this.commonService.convertWithWebCodecs(this.selectedFile));
      }
      // if (!this.isEdit && !this.selectedFile) {
      //   this.toastr.info('Please select an image to recommend');
      //   return;
      // }

      // if (
      //   this.roleService?.roles?.userType.includes('ADMIN') &&
      //   this.selectedSubRegion
      // ) {

      // }

      formData.append('pointOfContact', this.pointOfContact);
      console.log('additionalTags are', this.additionalTags);
      formData.append(
        'additionalTags',
        JSON.stringify([this.recommTypes[this.selectedRecommTypeIndex].name])
      );
      if (this.selectedSubRegion) {
        formData.append('subRegionId', this.selectedSubRegion.subRegionId);
      }
      if (this.pollId) {
        formData.append('pollId', this.pollId);
      }
      if(!this.isLoggedIn){
       
        formData.append('addedByNickname', this.addedByNickname)
      }
     
   

      if(this.optionalImageOneData){
        formData.append('optionalImageOne', await this.commonService.convertWithWebCodecs(this.optionalImageOneData) ?? '');

      }
      if(this.optionalImageTwoData){
        formData.append('optionalImageTwo', await this.commonService.convertWithWebCodecs(this.optionalImageTwoData) ?? '');

      }

      let subs;
      this.spinner.show();
      if (this.isEdit) {
        subs = this.auth.editRecommendation(this.editRecommId, formData, {
          reportProgress: true,
          observe: 'events',
        });
      } else {
      
        subs = this.auth.addRecommendations(formData, {
          reportProgress: true,
          observe: 'events',
        });
      }
     // this._clearForm();

      subs.subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            // Update progress percentage
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
            if(this.uploadProgress == 100){
              this.uploadProgress = 0;
             // this._clearForm()
            }
          } else if (event.type === HttpEventType.Response) {
            // console.warn({event})
            this.sharedService.addedNewRecommendation.next(event.body.data)
            this._clearForm()
            this.spinner.hide();
            
            this.toastr.success(
              `${this.isEdit ? 'Edited' : 'Added'} successfully`
            );
            if (!this.isEdit) {
              this.local
                .confirmYesNoWithImage({
                  title: 'Recommend Again?',
                  text: 'Would You Like To Recommend Again',
                  imageUrl: './../assets/images/w.jpeg',
                })
                .then((res) => {
                  if (res.isConfirmed) {
                    this._clearForm();
                  } else {
                    this.closeModal();
                  }
                });
              // this.local
              //   .confirmYesNo({
              //     title: 'Recommend Again?',
              //     text: 'Would You Like To Recommend Again',
              //     icon: 'question',
              //   })
              //   .then((res) => {
              //     if (res.isConfirmed) {
              //       this._clearForm();
              //     } else {
              //       this.closeModal();
              //     }
              //   });
            } else {
              //this.closeModal();
            }

            this.uploadProgress = 0;
            this.cdr.markForCheck()
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.uploadProgress = 0;
          this.cdr.markForCheck()
          console.error(err);
          this.toastr.error(
            `Error while ${
              this.isEdit ? 'Editing' : 'Adding'
            } recommendation ${err.error.message}`
          );
        },
      });
    } catch (e) {
      console.error(e);
    }
  }

  closeModal() {
    if (this.activeModal) {
      this.activeModal.dismiss('cancelled');
    }
    if (this.activeBottomSheet) {
      this.activeBottomSheet.dismiss();
    }
  }
}
